import Layout from '@/layout'

const hospitalManage = {
    path: '/financial',
    component: Layout,
    children: [
        {
            // 咨询回复
            path: '/counsel/consultingReply',
            name: 'consultingReply',
            component: () => import('@/views/doctor/counsel/consultingReply'),
            meta: { activeMenu: '/counsel/consultingReply', allCanVisit: true }
        },
        {
            // 视频管理
            path: '/counsel/videoManagement',
            name: 'videoManagement',
            component: () => import('@/views/doctor/counsel/videoManagement'),
            meta: { activeMenu: '/counsel/videoManagement', allCanVisit: true }
        },
        {
            // 视频管理 --新增视频
            path: '/counsel/videoManagement/add',
            name: 'addVideoManagement',
            component: () => import('@/views/doctor/counsel/addVideoManagement'),
            meta: { activeMenu: '/counsel/videoManagement', allCanVisit: true }
        },
        {
            // 视频管理 --编辑视频
            path: '/counsel/videoManagement/edit',
            name: 'editVideoManagement',
            component: () => import('@/views/doctor/counsel/editVideoManagement'),
            meta: { activeMenu: '/counsel/videoManagement', allCanVisit: true }
        },
        {
            // 常见问题
            path: '/counsel/commonProblem',
            name: 'commonProblem',
            component: () => import('@/views/doctor/counsel/commonProblem/problemList'),
            meta: { activeMenu: '/counsel/commonProblem', allCanVisit: true }
        },
        {
            // 常见问题 -- 新增
            path: '/counsel/commonProblem/add',
            name: 'addCommonProblem',
            component: () => import('@/views/doctor/counsel/commonProblem/addOrEdit'),
            meta: { activeMenu: '/counsel/commonProblem', allCanVisit: true }
        },
        {
            // 常见问题 -- 编辑
            path: '/counsel/commonProblem/edit',
            name: 'editCommonProblem',
            component: () => import('@/views/doctor/counsel/commonProblem/addOrEdit'),
            meta: { activeMenu: '/counsel/commonProblem', allCanVisit: true }
        }
    ]
}

export default hospitalManage
